import CheckboxWrapper from './CheckboxWrapper';

export default CheckboxWrapper;
